import axiosInstance from "./api_helper";

const SHIFT_BASE = "/api/shifts";

const shiftService = {

  /* ================= OPEN SHIFT ================= */
  openShift: (payload) => {
    // POST /api/shifts/open
    return axiosInstance.post(`${SHIFT_BASE}/open`, payload);
  },

  /* ================= CLOSE SHIFT ================= */
  closeShift: (id, payload) => {
    // PUT /api/shifts/{id}/close
    return axiosInstance.put(`${SHIFT_BASE}/${id}/close`, payload);
  },

  /* ================= VALIDATE SHIFT ================= */
  validateShift: (id, payload) => {
    // PUT /api/shifts/{id}/validate
    return axiosInstance.put(
      `${SHIFT_BASE}/${id}/validate`,
      payload
    );
  },

  /* ================= CANCEL SHIFT ================= */
  cancelShift: (id, reason) => {
    // PUT /api/shifts/{id}/cancel?reason=...
    return axiosInstance.put(
      `${SHIFT_BASE}/${id}/cancel`,
      null,
      {
        params: { reason }
      }
    );
  },

  /* ================= GET BY ID ================= */
  getById: (id) => {
    // GET /api/shifts/{id}
    return axiosInstance.get(`${SHIFT_BASE}/${id}`);
  },

  /* ================= GET SHIFT SUMMARY ================= */
  getSummary: (id) => {
    console.log(id)
    // GET /api/shifts/{id}/summary
    return axiosInstance.get(`${SHIFT_BASE}/${id}/summary`);
  },

  /* ================= FILTER SHIFTS ================= */
  filter: ({
    startDate,
    endDate,
    commercialId,
    status,
    pointOfSaleId,
  }) => {
    const params = {};

    if (startDate) params.startDate = startDate; // yyyy-MM-dd
    if (endDate) params.endDate = endDate;       // yyyy-MM-dd
    if (commercialId) params.commercialId = commercialId;
    if (status) params.status = status;           // OPEN, CLOSED, VALIDATED...
    if (pointOfSaleId) params.pointOfSaleId = pointOfSaleId;

    return axiosInstance.get(`${SHIFT_BASE}/filter`, { params });
  },

  /* ================= CHECK IF COMMERCIAL HAS OPEN SHIFT ================= */
  hasOpenShift: (commercialId) => {
    // GET /api/shifts/commercial/{id}/has-open
    return axiosInstance.get(
      `${SHIFT_BASE}/commercial/${commercialId}/has-open`
    );
  },

  /* ================= GET OPEN SHIFT FOR COMMERCIAL ================= */
  getOpenShift: (commercialId) => {
    // GET /api/shifts/commercial/{id}/open
    return axiosInstance.get(
      `${SHIFT_BASE}/commercial/${commercialId}/open`
    );
  },

  /* ================= DASHBOARD STATS ================= */
  getDashboardStats: (date) => {
    // GET /api/shifts/dashboard/stats?date=YYYY-MM-DD
    return axiosInstance.get(
      `${SHIFT_BASE}/dashboard/stats`,
      { params: { date } }
    );
  }

};

export default shiftService;
